import { type DefaultTheme, type FlattenInterpolation, type ThemeProps, css } from 'styled-components';

/**
 * This component is used in global-styles.ts due to problems with overriding styles of ant-component's checkboxes in other components.
 */
export const getTreeSelectCheckboxStyles = (): FlattenInterpolation<ThemeProps<DefaultTheme>> => css`
  &&& {
    .ant-select-tree-checkbox-inner {
      border-color: ${({ theme }) => theme.color.semantic.primary.border.default};
    }
    .ant-select-tree-checkbox:hover {
      .ant-select-tree-checkbox-inner {
        background-color: ${({ theme }) => theme.color.semantic.toggle.background.selected.default};
      }
    }

    .ant-select-tree-checkbox-checked {
      .ant-select-tree-checkbox-inner {
        border-color: ${({ theme }) => theme.color.semantic.primary.border.default};
        background-color: ${({ theme }) => theme.color.semantic.primary.background.default};
      }
    }

    .ant-select-tree-checkbox-checked:hover {
      .ant-select-tree-checkbox-inner {
        border-color: ${({ theme }) => theme.color.semantic.primary.background.hover};
        background-color: ${({ theme }) => theme.color.semantic.primary.background.hover};
      }
    }
  }
`;
